import type { PropsWithChildren } from "react";
import React, { memo } from "react";
import * as Styles from "./Loader.styles";
import Text from "../atoms/Text";

type LoaderPropsType = {
    label?: string;
    loaderWrapperHeight?: number;
    loaderSize?: number;
    square?: boolean;
    fullscreen?: boolean;
    backdrop?: boolean;
    delayedVisibility?: boolean;
};

const Loader: React.FC<PropsWithChildren<LoaderPropsType>> = (props) => {
    const { label, loaderWrapperHeight, square, fullscreen, backdrop, loaderSize, delayedVisibility } = props;
    return (
        <>
            <Styles.Wrapper square={square} fullscreen={fullscreen} loaderHeight={loaderWrapperHeight}>
                <Styles.Preloader hasLabel={!!label} size={loaderSize} delayedVisibility={delayedVisibility} />
                {label && (
                    <Text variant="paragraph-small-regular" color="red">
                        {label}
                    </Text>
                )}
            </Styles.Wrapper>
            {backdrop && <Styles.Backdrop />}
        </>
    );
};

export default memo(Loader);
